import moment from 'moment-timezone';

export default () => {
  const a = moment().startOf('day').utc().format('MM/DD/YYYY 00:00:00');
  const b = moment().format('MM/DD/YYYY 00:00:00');
  const dayDiff = moment(b).diff(a, 'hours');

  const offset = moment(moment().format('MM/DD/YYYY 00:00:00')).utc().hours();

  return `${offset - dayDiff} HOUR`;
};
